module.exports = __webpack_public_path__ + "static/media/nervosity-mismatch-2-fr.6022cde0.png";